import { IpaType } from "../../phonemes/ipa";

const rhotics = ['ɹ', 'ɾ', 'r', 'ɽ', 'ɻ'];

/** format a lexical set phoneme for display, e.g., 'eɪ̯' or 'ɑː(ɹ)' */
export function lsUnitForDisplay(phoneme: IpaType, nonRhotic?: boolean): IpaType {
  if (!nonRhotic) {
    return phoneme;
  }

  const last = phoneme[phoneme.length - 1];
  if (!rhotics.includes(last)) {
    return phoneme;
  }

  return `${phoneme.substring(0, phoneme.length - 1)}(${last})`;
}

/** in a non-rhotic accent, return the non-rhotic portion of a phoneme */
export function nonRhoticUnit(phoneme: IpaType, nonRhotic?: boolean): IpaType {
  phoneme = breakRhotic(phoneme);
  return phonemeForLength(phoneme, nonRhotic);
}

/** the portion of a phoneme needed for listing the phoneme length */
export function phonemeForLength(phoneme: IpaType, nonRhotic?: boolean): IpaType {
  const last = phoneme[phoneme.length - 1];
  if (last !== 'ɹ' && rhotics.includes(last)) {
    // always strip off the non-ɹ rhotics because they're not used for phoneme length
    return phoneme.substring(0, phoneme.length - 1);
  }

  if (!nonRhotic || last !== 'ɹ') {
    return phoneme;
  }

  return phoneme.substring(0, phoneme.length - 1);
}

/** break single-rhotic-symbols into vowel/rhotic */
export function breakRhotic(p: IpaType): IpaType {
  if (p === 'ɝ') return 'ɜɹ';
  if (p === 'ɝː') return 'ɜːɹ';
  if (p === 'ɚ') return 'əɹ';
  if (p === 'ɚː') return 'əːɹ';
  if (p[1] === '˞') return `${p[0]}ɹ`;
  return p;
}
